/** Reference rates (tokens per 1 USD) for estimate UI — replace with API feed when available. */
export const EXCHANGE_ASSETS = [
  {
    id: "polygon-usdc",
    label: "Polygon USDC",
    short: "USDC",
    network: "Polygon",
    /** How many USDC per 1 USD before fees (stablecoin reference). */
    tokensPerUsd: 0.9994,
    feeFraction: 0.04,
    changePct: 0.12,
    iconLetter: "U",
  },
  {
    id: "bsc-usdt",
    label: "BSC USDT",
    short: "USDT",
    network: "BSC",
    tokensPerUsd: 0.9989,
    feeFraction: 0.05,
    changePct: -0.08,
    iconLetter: "T",
  },
];

export function getExchangeAsset(id) {
  return EXCHANGE_ASSETS.find((a) => a.id === id) ?? EXCHANGE_ASSETS[0];
}

/**
 * @param {number} usd - positive USD amount
 * @param {{ tokensPerUsd: number, feeFraction: number }} asset
 */
export function estimateConversion(usd, asset) {
  const u = Math.max(0, Number(usd) || 0);
  const gross = u * asset.tokensPerUsd;
  const net = gross * (1 - asset.feeFraction);
  return {
    usd: u,
    gross,
    net,
    feeFraction: asset.feeFraction,
    tokensPerUsd: asset.tokensPerUsd,
  };
}

/**
 * Inverse: net token amount (after fee) → required USD in.
 * net = usd * tokensPerUsd * (1 - fee)  ⇒  usd = net / (tokensPerUsd * (1 - fee))
 */
export function usdFromNetCrypto(netTokens, asset) {
  const n = Math.max(0, Number(netTokens) || 0);
  const denom = asset.tokensPerUsd * (1 - asset.feeFraction);
  if (denom <= 0) return 0;
  return n / denom;
}
